import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-impersonation-confirm-modal',
  templateUrl: './impersonation-confirm-modal.component.html',
  styleUrls: ['./impersonation-confirm-modal.component.scss']
})
export class ImpersonationConfirmModalComponent implements AfterViewInit {
  @Input() user: any;
  @Output() confirm = new EventEmitter<void>();
  isSubmitting = false;

  constructor(public activeModal: NgbActiveModal) {}

    ngAfterViewInit() {
      setTimeout(() => {
        const el = document.querySelector('.modal .btn-close') as HTMLElement;
        el?.blur();
      }, 50);
    }

  continue() {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.confirm.emit();
  }
}
